import React from "react";
import Homepage from "./component";
import withContext from "../../tools/withContext";

const ROLE_LABELS: Record<string, string> = {
  ROLE_ADMIN: "Administrateur",
  ROLE_PROJECT_ADMIN: "Admin projet",
  ROLE_LABELER: "Labeler",
};

const HomepageContainer = (props: any) => {
  const {
    ctx: { user },
  } = props;

  const authority = user?.authorities?.[0] ?? "";
  const isAdmin =
    authority === "ROLE_ADMIN" || authority === "ROLE_PROJECT_ADMIN";
  const roleLabel = ROLE_LABELS[authority] ?? authority;

  return (
    <Homepage user={user} isAdmin={isAdmin} roleLabel={roleLabel} />
  );
};

export default withContext(HomepageContainer);
